import { apiSlice } from "./apiSlice";

export const teacherApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeacherAssignedSubjects: builder.query({
      query: () => "/teacher/subjects",
      providesTags: ["TeacherSubjects"],
    }),
    getClassroomStudents: builder.query({
      query: ({ classroom_id, classroomId }) => `/classroom/${classroom_id ?? classroomId}/students`,
      providesTags: ["ClassroomStudents"],
    }),
  }),
});

export const { useGetTeacherAssignedSubjectsQuery, useGetClassroomStudentsQuery } = teacherApiSlice;
